import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCloudMove = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cloud-move';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.7 3.267A5.21 5.21 0 0 0 7.32 6.18c-.222.448-.437 1.086-.5 1.49-.021.131-.047.174-.114.188-.642.129-1.083.271-1.526.491a5.3 5.3 0 0 0-2.765 3.446c-.602 2.372.527 4.884 2.694 5.998.912.468 1.421.57 2.981.597l1.149.02.011 1.664.01 1.665 2.12-2.017c1.166-1.109 2.118-2.037 2.115-2.064-.002-.026-.956-1.058-2.12-2.293L9.26 13.119l-.01 1.884-.011 1.883-1.189-.015c-1.162-.015-1.199-.018-1.55-.126-.679-.207-1.126-.467-1.591-.926a3.7 3.7 0 0 1-.791-1.114c-.274-.585-.332-.866-.332-1.625 0-.603.009-.69.107-1.012.35-1.143 1.031-1.939 2.079-2.428.531-.248.723-.287 1.532-.309l.724-.02.025-.631c.036-.919.146-1.368.489-1.992a3.8 3.8 0 0 1 2.318-1.815c.266-.073.425-.087.94-.087s.674.014.94.087c.992.273 1.831.93 2.318 1.815.343.624.453 1.073.489 1.992l.025.631.724.02c.809.022 1.001.061 1.532.309 1.048.489 1.729 1.285 2.079 2.428.098.322.107.409.107 1.012 0 .548-.015.712-.085.968-.298 1.085-1.103 2.056-2.066 2.495a4.7 4.7 0 0 1-1.243.328l-.32.029v1.48l.28-.012a5.3 5.3 0 0 0 1.36-.254c2.623-.894 4.123-3.646 3.445-6.319-.489-1.926-2.004-3.42-3.905-3.852l-.383-.084c-.068-.014-.095-.075-.153-.348-.345-1.629-1.37-2.978-2.816-3.707a5.44 5.44 0 0 0-2.628-.537"
    })
  }));
});
export default SvgCloudMove;